export default "__VITE_ASSET__ZuriyeQR__"